export default "__VITE_ASSET__Cb3q5iUM__"